<template>
  <div class="login-container d-flex">
    <!-- LADO IZQUIERDO (branding) -->
    <div class="left-panel d-none d-md-flex flex-column align-center justify-center">
      <div class="branding">
        <h1 class="title">¡Bienvenido! 👋</h1>
        <p class="subtitle">
          Plataforma de Gestión TI Experticia.
        </p>
      </div>
    </div>

    <!-- LADO DERECHO: FORMULARIO -->
    <div class="right-panel d-flex align-center justify-center">
      <v-card
        class="pa-8 white-card login-card"
        elevation="8"
        max-width="420"
      >
        <v-card-title class="justify-center login-title">
          Iniciar Sesión
        </v-card-title>

        <v-form @submit.prevent="handleLogin">
          <v-card-text>
            <v-text-field
              v-model="correo"
              label="Correo Electrónico"
              type="email"
              outlined
              dense
              prepend-inner-icon="mdi-email"
            />

            <v-text-field
              v-model="password"
              label="Contraseña"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              prepend-inner-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"
            />

            <v-alert
              v-if="error"
              type="error"
              dense
              outlined
              class="mt-2"
            >
              {{ error }}
            </v-alert>
          </v-card-text>

          <v-card-actions class="d-flex flex-column">
            <v-btn
              color="primary"
              block
              large
              :loading="loading"
              type="submit"
              class="mb-3 primary-btn"
            >
              Ingresar
            </v-btn>

          </v-card-actions>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API_BASE from "@/helpers/api";
import { eventBus } from "@/helpers/eventBus";

export default {
  data() {
    return {
      correo: "",
      password: "",
      showPassword: false,
      error: "",
      loading: false,
    };
  },
  created() {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("usuario");
  },
  methods: {
async handleLogin() {
  this.loading = true;
  this.error = "";

  try {
    const response = await axios.post(`${API_BASE}/auth/login`, {
      correo: this.correo,
      password: this.password,
    });

    sessionStorage.setItem("token", response.data.token);
    sessionStorage.setItem("usuario", JSON.stringify(response.data.usuario));

    eventBus.$emit("usuario-logeado", response.data.usuario);

    //  REDIRECCIÓN POR ROL
    const rol = (response.data.usuario?.rol || "").trim().toLowerCase();

    if (rol === "visualizador") {
      this.$router.push("/dashboards");
    } else {
      this.$router.push("/inicio");
    }

  } catch (err) {
    this.error = "Credenciales inválidas";
  } finally {
    this.loading = false;
  }
}
  },
};
</script>

<style scoped>
/* ===== LAYOUT GENERAL ===== */
.login-container {
  height: 100vh;
  overflow: hidden;
  background-color: #dceff8;
}

/* PANEL IZQUIERDO (branding) */
.left-panel {
  width: 50%;

  /* Fondo corporativo + Logo */
  background:
    linear-gradient(135deg, rgba(2,147,211,0.95), rgba(2,112,161,0.95)),
    url('@/assets/Isotipo Gris.png');

  background-size: 100%;        /* tamaño del logo */
  background-repeat: no-repeat;
  background-position: center; /* posición del logo */

  color: #ffffff;
  padding: 40px;
}

.branding {
  max-width: 420px;
}

.title {
  font-size: 2.6rem;
  font-weight: 800;
}

.subtitle {
  font-size: 1.15rem;
  margin-top: 12px;
  opacity: 0.95;
}

/* PANEL DERECHO (formulario) */
.right-panel {
  width: 50%;
}

.login-card {
  border-radius: 16px;
}

.login-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: #0293d3;
}

/* BOTONES */
.primary-btn {
  background-color: #0293d3 !important;
  color: #ffffff !important;
}

.secondary-btn {
  border-color: #0293d3 !important;
  color: #0293d3 !important;
}


.white-card {
  background-color: #ffffff !important;
  color: #27282a !important;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.global-dashboard-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* modo claro */
.theme--light .white-card {
  background-color: #ffffff !important;
  color: #27282a !important;
}

/* modo oscuro */
.theme--dark .white-card {
  background-color: #131212bf !important;
  color: #ffffff !important;
}

.theme--light .global-dashboard-card {
  background-color: #ffffff;
  color: #27282a;
}


@media (max-width: 960px) {
  .left-panel {
    display: none !important;
  }
  .right-panel {
    width: 100%;
  }
}
/* Panel derecho – modo claro */
.theme--light .right-panel {
  background: #f4f6fb !important;
}

/* Panel derecho – modo oscuro */
.theme--dark .right-panel {
  background: #1e1e1e !important;
}
</style>